<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  async created() {
    const accessRoutes = await this.$store.dispatch('permission/generateRoutes');
    // dynamically add accessible routes
    this.$router.addRoutes(accessRoutes);
  },
};
</script>
